import axios from "axios";
const URLS = "https://plasticsmartcities.wwf.id/aksi/api";
var TOKEN = sessionStorage.getItem('token');

export default {
   actions: {
      setToken(data){
         TOKEN = data
      },
      get_news(filter, sort, search) {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/articles?limit=50&filter[type]=${filter}&filter[title]=${search}&sort=${sort}`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                     }
                  })
                  .then((response) => {
                     resolve(response?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
      get_news_detail(filter) {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/articles/${filter}`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                     }
                  })
                  .then((response) => {
                     resolve(response?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                     // console.log('oko', err)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
      get_news_partner(filter) {
         return new Promise((resolve, reject) => {
            try {
               axios
                  .get(URLS + `/v1/client/articles?filter[author_id]=${filter}`, {
                     headers:{
                        Authorization: `Bearer ${TOKEN}`,
                        'Access-Control-Allow-Origin': '*',
                     }
                  })
                  .then((response) => {
                     resolve(response?.data);
                  }).catch((err) => {
                     reject(err?.response?.data)
                     // console.log('oko', err)
                  });
               } catch (error) {
                  console.log(error);
               }
            });
      },
   },
};


